<template>
  <div class="news">
    <Header />
    <div class="category mt-82">
      <div class="category-img">
        <img src="@/assets/image/news/banner.png" alt="" />
      </div>
    </div>
    <div class="category-list">
      <ul>
        <li>
          <a href="#companyNews">{{ $t("common.news.companyNews") }}</a>
        </li>
        <li>
          <a href="#industry">{{ $t("common.news.industry") }}</a>
        </li>
        <li>
          <a href="#media">{{ $t("common.news.media") }}</a>
        </li>
      </ul>
    </div>
    <!-- 公司动态 -->
    <div class="companyNews module" id="companyNews">
      <div>
        <div class="title">{{ $t("common.news.companyNews") }}</div>
      </div>
      <div class="common-width">
        <ul>
          <li class="tal">
            <div class="companyNews-left">
              <img src="@/assets/image/news/1.jpg" alt="" />
            </div>
            <div class="companyNews-right ml-38">
              <h3 class="mb-24">
                {{ $t("news.companyNews.p1.title") }}
              </h3>
              <div>
                {{ $t("news.companyNews.p1.content") }}
              </div>
              <span class="mt-21">2020-03-30</span>

              <router-link
                class="mt-52 pointer"
                tag="p"
                :to="{ name: 'Detail', query: { index: 1 } }"
                >{{ $t("common.common.more") }}>></router-link
              >
            </div>
          </li>
          <li class="tal mt-48">
            <div class="companyNews-left">
              <img src="@/assets/image/news/2.jpg" alt="" />
            </div>
            <div class="companyNews-right ml-38">
              <h3 class="mb-24">
                {{ $t("news.companyNews.p2.title") }}
              </h3>
              <div>
                {{ $t("news.companyNews.p2.content") }}
              </div>
              <span class="mt-21">2020-03-30</span>

              <router-link
                class="mt-52 pointer"
                tag="p"
                :to="{ name: 'Detail', query: { index: 0 } }"
                >{{ $t("common.common.more") }}>></router-link
              >
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 行业资讯 -->
    <div class="industry module" id="industry">
      <div>
        <div class="title">{{ $t("common.news.industry") }}</div>
      </div>
      <div class="common-width">
        <h3>{{ $t("news.industry.title") }}</h3>
        <ul>
          <li class="tal">
            <p class="industry-title">{{ $t("news.industry.p1.title") }}</p>
            <div class="industry-content">
              {{ $t("news.industry.p1.content") }}
            </div>
            <div class="time">
              <span class="time-l">{{ $t("news.industry.p1.time") }}</span>

              <router-link
                class="time-r pointer"
                tag="span"
                :to="{ name: 'Detail', query: { index: 4 } }"
                >{{ $t("common.common.more") }}>></router-link
              >
            </div>
          </li>
          <li class="tal">
            <p class="industry-title">{{ $t("news.industry.p2.title") }}</p>
            <div class="industry-content">
              {{ $t("news.industry.p2.content") }}
            </div>
            <div class="time">
              <span class="time-l">{{ $t("news.industry.p2.time") }}</span>
              <router-link
                class="time-r pointer"
                tag="span"
                :to="{ name: 'Detail', query: { index: 3 } }"
                >{{ $t("common.common.more") }}>></router-link
              >
            </div>
          </li>
          <li class="tal">
            <p class="industry-title">{{ $t("news.industry.p3.title") }}</p>
            <div class="industry-content">
              {{ $t("news.industry.p3.content") }}
            </div>
            <div class="time">
              <span class="time-l">{{ $t("news.industry.p3.time") }}</span>
              <router-link
                class="time-r pointer"
                tag="span"
                :to="{ name: 'Detail', query: { index: 2 } }"
                >{{ $t("common.common.more") }}>></router-link
              >
            </div>
          </li>
          <li></li>
        </ul>
      </div>
    </div>
    <!-- 媒体报道 -->
    <div class="media module" id="media">
      <div>
        <div class="title">{{ $t("common.news.media") }}</div>
      </div>
      <div class="common-width">
        <div>
          <ul>
            <li>
              <div>
                <img src="@/assets/image/news/3.jpg" alt="" />
                <div>
                  {{ $t("news.media.p1.title") }}
                </div>
                <p>
                  <!-- https://m.chinanews.com/wap/detail/zw/ty/2020/01-09/9054905.shtml?replace=1 -->
                  <a class="pointer" @click="openWindow"
                    >{{ $t("common.common.more") }}>></a
                  >
                </p>
              </div>
            </li>
            <li>
              <div>
                <img src="@/assets/image/news/4.jpg" alt="" />
                <div>
                  {{ $t("news.media.p2.title") }}
                </div>
                <p>
                  <a
                    class="pointer"
                    target="_blank"
                    href="https://view.inews.qq.com/a/20200201A0HNBD00?uid=&devid=0565C6BB-FEFE-46E1-A03F-44F27C355FE9&qimei=0565c6bb-fefe-46e1-a03f-44f27c355fe9"
                    >{{ $t("common.common.more") }}>></a
                  >
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "@/components/Header";
export default {
  name: "News",
  components: {
    Header
  },
  watch: {
    $route(to, from) {
      const id = from.query.id;
      if (id) {
        document.getElementById(id).scrollIntoView();
      }
    }
  },
  mounted() {
    const id = this.$route.query.id;
    if (id) {
      document.getElementById(id).scrollIntoView();
    }
  },
  methods: {
    openWindow() {
      window.open(
        "https://m.chinanews.com/wap/detail/zw/ty/2020/01-09/9054905.shtml?replace=1"
      );
    }
  }
};
</script>
<style lang="stylus" scoped>
.companyNews
  padding-bottom 100px
  ul
    li
      display flex
      .companyNews-right
        text-align left
        display flex
        justify-content center
        flex-direction column
        color #191818
        div
          font-size 18px
          color #666
        span
          font-size 16px
          color #aaa
        p
          font-size 20px
          color #333
        h3
          font-size 22px
          color #191919
.industry
  background #FAFAFA
  padding-bottom 100px
  h3
    font-size 30px
    font-weight 500
    font-style italic
    color rgba(25,24,24,1)
    margin-bottom 30px
  .common-width
    width 1100px
  ul
    display flex
    justify-content space-around
    flex-wrap wrap
    li
      width 500px
      margin-bottom 27px
      padding 20px 36px
      background rgba(255,255,255,1)
      border 1px solid rgba(224, 223, 223, 1)
      &:hover
        box-shadow 0px 6px 10px 0px rgba(40,96,240,0.15)
      p
        font-size 22px
        color #191818
        margin-bottom 24px
    .industry-content
      font-size 18px
      text-indent 36px
      line-height 1.8
      color #666
    .time
       margin-top 36px
      .time-l
        font-size 18px
        color #aaa
      .time-r
        font-size 20px
        color #1F6BDC
        float right
.media
  padding-bottom 100px
  ul
    display flex
    justify-content space-around
    li
      width 540px
      background rgba(255,255,255,1)
      overflow hidden
      border 1px solid rgba(224, 223, 223, 1)
      &:hover
        box-shadow 0px 6px 10px 0px rgba(40,96,240,0.15)
      div
        >div
          padding 30px 44px
          color #191919
          font-size 22px
          font-weight bold
          text-align left
          height 120px
      p
        color #1F6BDC
        font-size 20px
        float right
        margin-right 40px
        padding-bottom 30px
        a
          text-decoration none
          color #1F6BDC
      img
        width 100%
</style>
